// extracted by mini-css-extract-plugin
export var header = "Header-module--header--NXzL8";
export var header__brand = "Header-module--header__brand--2sBXE";
export var header__brand__casio = "Header-module--header__brand__casio--PBrkJ";
export var header__brand__classpad = "Header-module--header__brand__classpad--9w4xl";